/* Lensvelt theme — small, dependency-free behaviours.
   Every feature looks for its own markup and does nothing if it is absent. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---- menu overlay: the page behind it doesn't scroll; the icon only moves on a click (lines ⇄ chair) ---- */
  const menu = $('#menu');
  if (menu) {
    const burger = $('.hdr [data-menu-open]');
    const open = () => { menu.classList.add('open'); menu.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('menu-on'); };
    const close = () => {
      if (!menu.classList.contains('open')) return;
      menu.classList.remove('open'); menu.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('menu-on');
      // the header icon starts as the chair the menu showed and folds back into lines
      if (burger) { burger.classList.add('chair', 'snap'); burger.offsetWidth; burger.classList.remove('chair', 'snap'); }
    };
    $$('[data-menu-open]').forEach(b => b.addEventListener('click', open));
    $$('[data-menu-close]').forEach(b => b.addEventListener('click', close));
    $$('nav a', menu).forEach(a => a.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  /* ---- page-end statement (.psit) goes below the "→" links block, so those links hang right under the last block ---- */
  const nxs = $('.nxs');
  if (nxs) $$('.psit').reverse().forEach(p => { p.classList.add('wrap'); nxs.after(p); });

  /* ---- header search: folds open, focus in the field; a second click with text searches ---- */
  const hs = $('[data-hsearch]');
  if (hs) {
    const inp = $('.hsearch-in', hs);
    const shut = () => { hs.classList.remove('open'); inp.tabIndex = -1; };
    $$('[data-hsearch-open]', hs).forEach(a => a.addEventListener('click', e => {
      e.preventDefault();
      if (hs.classList.contains('open') && inp.value.trim()) return hs.submit();
      hs.classList.add('open'); inp.tabIndex = 0; inp.focus();
    }));
    hs.addEventListener('submit', e => { if (!inp.value.trim()) { e.preventDefault(); inp.focus(); } });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && hs.classList.contains('open')) { shut(); inp.blur(); } });
    document.addEventListener('click', e => { if (!hs.contains(e.target) && !inp.value.trim()) shut(); });
  }

  /* ---- search page: × empties the field; with results on screen it goes back to an empty search (sections/main-search) ---- */
  $$('[data-sclear]').forEach(x => {
    const inp = $('input[type=search]', x.closest('form'));
    const sync = () => { x.hidden = !inp.value && !x.dataset.terms; };
    inp.addEventListener('input', sync);
    x.addEventListener('click', e => { if (x.dataset.terms) return; e.preventDefault(); inp.value = ''; sync(); inp.focus(); });
    sync();
  });

  /* ---- reveal on scroll ---- */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: .15 })
    : null;
  const watch = root => $$('.rv', root).forEach(el => io ? io.observe(el) : el.classList.add('in'));
  watch(document);

  /* ---- wordmarks fit edge to edge ---- */
  const fit = () => $$('.fitword:not(.is-logo)').forEach(el => {
    const box = el.parentElement, cs = getComputedStyle(box);
    const avail = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    el.style.fontSize = '100px';
    el.style.fontSize = (100 * avail / el.scrollWidth * .995) + 'px';
  });
  fit();
  addEventListener('resize', fit);
  document.fonts && document.fonts.ready.then(fit);

  /* ---- accordions (stories) ---- */
  document.addEventListener('click', e => {
    const h = e.target.closest('.acc-head');
    if (!h) return;
    const it = h.parentElement, o = !it.classList.contains('open');
    it.classList.toggle('open', o);
    h.setAttribute('aria-expanded', o);
  });

  /* ---- designer hover preview: trails the cursor a little; the next photo cross-fades over the last one ---- */
  const dp = $('#dprev');
  if (dp) {
    const a = $('img', dp), b = a.cloneNode();
    a.classList.add('cur'); dp.append(b);
    let x = 0, y = 0, tx = 0, ty = 0, raf = 0, want = '';
    const place = () => { dp.style.left = x + 'px'; dp.style.top = y + 'px'; };
    const step = () => { x += (tx - x) * .2; y += (ty - y) * .2; place(); raf = Math.abs(tx - x) + Math.abs(ty - y) > .5 ? requestAnimationFrame(step) : 0; };
    document.addEventListener('mousemove', e => { tx = e.clientX; ty = e.clientY; if (!raf) raf = requestAnimationFrame(step); });
    const show = src => {
      const cur = $('img.cur', dp), next = cur === a ? b : a;
      if (!dp.classList.contains('on')) { x = tx; y = ty; place(); want = src; cur.src = src; dp.classList.add('on'); return; } // appears at the cursor, no fade from an old photo
      if (src === want) return;
      want = src; next.src = src;
      (next.decode ? next.decode() : Promise.resolve()).catch(() => {}).then(() => { if (want === src) { next.classList.add('cur'); cur.classList.remove('cur'); } });
    };
    $$('.drow').forEach(r => r.addEventListener('mouseenter', () => r.dataset.img ? show(r.dataset.img) : dp.classList.remove('on')));
    $$('.dlist').forEach(l => l.addEventListener('mouseleave', () => dp.classList.remove('on')));
  }

  /* ---- homepage panels side by side: every title as tall as the tallest in its row (exact heights, no rounding),
     so the titles start on one line and the texts below them start on one line ---- */
  $$('.split-2').forEach(sp => {
    const hs = $$(':scope > * .cap h3', sp);
    const ht = h => h.getBoundingClientRect().height;
    const eq = () => {
      hs.forEach(h => { h.style.minHeight = ''; });
      const rows = new Map();
      hs.forEach(h => { const k = h.closest('.split > *').offsetTop; rows.set(k, (rows.get(k) || []).concat(h)); });
      rows.forEach(r => { if (r.length < 2) return; const m = Math.max(...r.map(ht)); r.forEach(h => { h.style.minHeight = m.toFixed(2) + 'px'; }); });
    };
    eq(); addEventListener('resize', eq); document.fonts && document.fonts.ready.then(eq);
  });

  /* ---- film band: plays muted in view, play/pause + sound ---- */
  $$('[data-film]').forEach(wrap => {
    const v = $('video', wrap), pb = $('[data-film-play]', wrap), sb = $('[data-film-sound]', wrap);
    if (!v) return;
    let userPaused = false;
    // phones (iOS) only autoplay when the video is muted in code too
    v.muted = true; v.defaultMuted = true; v.playsInline = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    const tryPlay = () => { if (!userPaused) v.play().catch(() => {}); };
    tryPlay();
    ['touchstart', 'scroll', 'click'].forEach(ev => addEventListener(ev, function once() { tryPlay(); removeEventListener(ev, once); }, { passive: true }));
    const sync = () => { if (pb) pb.textContent = v.paused ? pb.dataset.play : pb.dataset.pause; if (sb) sb.textContent = v.muted ? sb.dataset.on : sb.dataset.off; };
    ['play', 'pause', 'volumechange'].forEach(ev => v.addEventListener(ev, sync));
    pb && (pb.onclick = () => { if (v.paused) { userPaused = false; v.play(); } else { userPaused = true; v.pause(); } });
    sb && (sb.onclick = () => { v.muted = !v.muted; if (!v.muted && v.paused) { userPaused = false; v.play(); } });
    if ('IntersectionObserver' in window) new IntersectionObserver(es => es.forEach(e => {
      if (e.intersectionRatio >= .4) { if (!userPaused) v.play().catch(() => {}); } else v.pause();
    }), { threshold: [0, .4, 1] }).observe(v);
    sync();
  });

  /* ---- designer products: exact designer via the metafield filter (sections/designer-grid).
     Fallback when the store cannot filter on that field (a rich text field, as in Ivo's store): fetch every product once
     and match the designer name in the theme; all pages share one fetch. ---- */
  const norm = s => (s || '').trim().replace(/\s+/g, ' ').toLowerCase();
  let allTiles = null;
  const fetchAllTiles = async base => {
    if (allTiles) return allTiles;
    const out = [];
    for (let page = 1; page <= 8; page++) {
      const doc = new DOMParser().parseFromString(await (await fetch(base + 'collections/all?section_id=designer-grid&page=' + page)).text(), 'text/html');
      const els = $$('[data-grid-out] > [data-handle]', doc);
      if (!els.length) break;
      out.push(...els);
      if (els.length < 48) break;
    }
    return (allTiles = out);
  };
  $$('[data-designer-grid]').forEach(async box => {
    const name = (box.dataset.name || '').trim();
    const limit = Number(box.dataset.limit || 48), skip = box.dataset.exclude || '';
    const empty = box.parentElement && $('[data-designer-empty]', box.parentElement);
    /* spellings merged in Theme settings ("Piet Heijn Eek | Piet Hein Eek"): a product with the other spelling still counts */
    const alias = new Map((box.dataset.aliases || '').split('\n').map(l => l.split('|')).filter(p => p.length === 2 && p[1].trim()).map(([a, b]) => [norm(a), b.trim()]));
    const canon = s => norm(alias.get(norm(s)) || s);
    /* no products: leave the whole block out (heading included) instead of an empty grid; the designer page itself stays,
       without its "View the collection ↓" link */
    const done = n => {
      box.removeAttribute('aria-busy');
      if (n) return;
      const s = box.closest(box.dataset.inline !== undefined ? '[data-related]' : 'section');
      /* "More from" on a product page: the designer's only product keeps the designer card (the link to the designer page),
         under "Designed by …" */
      if (s && s.matches('[data-related]') && $('.designer-card', s)) { const h = $('h2', s); if (h && s.dataset.alone) h.textContent = s.dataset.alone; s.classList.add('is-alone'); return; }
      if (s) { if (s.id === 'products') $$('a[href="#products"]').forEach(a => a.remove()); s.remove(); } else if (empty) empty.hidden = false;
    };
    if (!name) return done(0);
    try {
      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      /* a shared product has one name in its designer field, and a store can spell a name in more ways: the designer view
         can add those names (designer-feature, "Ook producten van", separated by ; because a misspelling can hold a comma) */
      const also = box.dataset.inline === undefined && $('[data-designer-also]');
      const names = [name].concat(also ? also.dataset.designerAlso.split(';') : []).map(s => s.trim()).filter(Boolean);
      const all = [], seen = new Set();
      /* hidden products (circular pool, retired) come back as empty wrappers: leave them out */
      const take = (els, nm) => els.forEach(el => {
        if (el.dataset.handle !== skip && el.children.length && canon(el.dataset.designer) === canon(nm) && !seen.has(el.dataset.handle)) { seen.add(el.dataset.handle); all.push(el); }
      });
      let filtered = true;
      for (const nm of names) {
        const url = base + 'collections/all?filter.p.m.' + (box.dataset.mf || 'custom.designer') + '=' + encodeURIComponent(nm) + '&section_id=designer-grid';
        const els = $$('[data-grid-out] > [data-handle]', new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html'));
        /* only this exact designer: an unknown filter value makes Shopify return every product (then we match ourselves).
           Judged on the designer's own name; an alias with no products returns everything too but proves nothing */
        if (nm === names[0] && els.some(el => canon(el.dataset.designer) !== canon(nm))) filtered = false;
        take(els, nm);
      }
      /* the filter did not filter (field not filterable, e.g. rich text, as in Ivo's store): match against every product.
         The grid still shows the first [limit]; the "show all" link goes to the furniture page with ?designer= set */
      if (!filtered) { const every = await fetchAllTiles(base); names.forEach(nm => take(every, nm)); }
      const items = all.slice(0, limit);
      items.forEach(el => { while (el.firstChild) box.appendChild(el.firstChild); });
      const more = box.parentElement && $('[data-designer-more]', box.parentElement);
      if (more && all.length > limit) { const t = $('[data-text]', more); t.textContent = t.dataset.text.replace('{count}', all.length); more.hidden = false; }
      watch(box);
      done(items.length);
    } catch (e) { done(0); }
  });

  /* ---- YMQ Product Options (Ivo's store): the app's options move to the top of the buy-box and get the configurator look
     (base.css .ymq-skin). YMQ keeps all the logic: which options show, required fields, surcharges, sku and the cart properties.
     Moving its element is safe (tested: conditions and sku keep working). Long swatch lists show 22 and a "Show all" bar. ---- */
  $$('.pdp-buy').forEach(buy => {
    const form = $('form[action*="/cart/add"]', buy), slot = form && $('.price-row', form);
    if (!slot) return;
    const clip = y => $$('.ymq-options-box', y).forEach(box => {
      if (box.dataset.clipped || !$('.ymq-option-swatches-input', box)) return;
      const items = $$('.ymq-option-value-item', box);
      if (items.length <= 22) return;
      box.dataset.clipped = '1';
      items.slice(22).forEach(i => i.classList.add('ymq-more'));
      const btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'cfg-more ymq-more-btn';
      const more = (buy.dataset.ymqMore || 'Show all 999').replace('999', items.length), less = buy.dataset.ymqLess || 'Show less';
      btn.textContent = more;
      btn.addEventListener('click', () => { const open = box.classList.toggle('open'); btn.textContent = open ? less : more; });
      $('.ymq-option-value-items', box).after(btn);
    });
    // long radio lists (all fabrics) are opened by a YMQ switch further down: a "Show less" button right under
    // the list turns that switch off again, so YMQ itself hides the list
    const fold = y => $$('.ymq-options-box', y).forEach(box => {
      if (box.dataset.fold || $$('input[type="radio"].ymq-checkbox-radio', box).length <= 12) return;
      box.dataset.fold = '1';
      const btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'cfg-more ymq-more-btn ymq-fold';
      btn.setAttribute('aria-expanded', 'true');
      btn.textContent = buy.dataset.ymqLess || 'Show less';
      btn.addEventListener('click', () => {
        const on = $$('.ymq-option-switch:checked', y);
        const sw = on.find(s => box.compareDocumentPosition(s) & Node.DOCUMENT_POSITION_FOLLOWING) || on[on.length - 1];
        if (!sw) return;
        sw.click();
        const top = $('.ymq-wrap', buy).getBoundingClientRect().top;
        if (top < 0) scrollBy({ top: top - 80, behavior: 'smooth' });
      });
      $('.ymq-option-value-items', box).after(btn);
    });
    // checkbox filters that YMQ doesn't send to the cart (fabric "Show Catagory"): hidden in base.css, all kept on,
    // so every fabric is pickable straight away; clicked like a customer would, so YMQ updates its own conditions
    const unfilter = y => $$('.ymq-options-box[ymq-option-add-to-cart="0"] input[type="checkbox"].ymq-checkbox-radio:not(.ymq-option-switch):not(:checked)', y)
      .forEach(i => i.click());
    // Shopify variant options that YMQ repeats as a dropdown (.ymq-shopify-option-box) are hidden in base.css: our own
    // option chips stay, and pass each choice on to YMQ's dropdown so its prices and sku follow the variant
    form.addEventListener('change', e => {
      const fs = e.target.closest('fieldset.opts'), name = fs && $('legend .muted', fs)?.textContent.trim();
      if (!name) return;
      $$('.ymq-shopify-option-box', form).forEach(b => {
        const s = $('select', b);
        if (!s || b.getAttribute('ymq-option-label') !== name || s.value === e.target.value) return;
        if (![...s.options].some(o => o.value === e.target.value)) return;
        s.value = e.target.value;
        s.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    const el = (t, cls, txt) => { const e = document.createElement(t); if (cls) e.className = cls; if (txt) e.textContent = txt; return e; };
    const clean = t => t.replace(/\s*\(MOQ[= ]?(\d+)\)/gi, ' · min. $1 pcs').replace(/\s+/g, ' ').trim();
    // YMQ dropdowns become rows (as the Glides radios): every choice in view, no "Please choose".
    // A click sets YMQ's own select and fires its change event, so YMQ does the rest.
    const rows = y => $$('.ymq-options-box:not(.ymq-shopify-option-box)', y).forEach(box => {
      const s = $('select', box);
      if (!s || box.dataset.rows) return;
      box.dataset.rows = '1'; box.classList.add('ymq-has-rows');
      const list = el('div', 'ymq-rows');
      [...s.options].filter(o => o.value).forEach(o => {
        const m = o.text.match(/^(.*?)\s*(\(\s*[+-][^()]*\))\s*$/);  // "Ral color (MOQ=50) (+€65,00)": price at the end
        const b = el('button', 'ymq-row');
        b.type = 'button'; b.dataset.value = o.value;
        b.append(el('span', '', clean(m ? m[1] : o.text)));
        if (m) b.append(el('span', 'ymq-option-value-price', m[2]));
        b.addEventListener('click', () => { if (s.value === o.value) return; s.value = o.value; s.dispatchEvent(new Event('change', { bubbles: true })); });
        list.append(b);
      });
      const mark = () => $$('.ymq-row', list).forEach(b => b.setAttribute('aria-pressed', b.dataset.value === s.value));
      s.addEventListener('change', mark); mark();
      (s.closest('.ymq-option-select-wrapper') || s).after(list);
    });
    // RAL code fields get the RAL picker of the configurator: a dot per colour family, that family's swatches, any colour
    // (snapped to the nearest RAL) or the code typed in. It fills YMQ's own field, so sku and properties stay YMQ's.
    const RAL = Object.fromEntries('1000:cdba88,1001:d0b084,1002:d2aa6d,1003:f9a800,1004:e49e00,1005:cb8e00,1006:e29000,1007:e88c00,1011:af804f,1012:ddaf27,1013:e3d9c6,1014:ddc49a,1015:e6d2b5,1016:f1dd38,1017:f6a950,1018:faca30,1019:a48f7a,1020:a08f65,1021:f6b600,1023:f7b500,1024:ba8f4c,1026:ffff00,1027:a77f0e,1028:ff9b00,1032:e2a300,1033:f99a1c,1034:eb9c52,1035:908370,1036:80643f,1037:f09200,2000:d56f00,2001:b6481c,2002:bc3823,2003:f17829,2004:de5306,2005:ff4b11,2007:ffb700,2008:e86b22,2009:da530a,2010:cc5d29,2011:dd6e0f,2012:d1654e,2013:8f3e26,2017:fa4402,3000:a42821,3001:982323,3002:982222,3003:841922,3004:691b23,3005:58181f,3007:3d2022,3009:663029,3011:772424,3012:c2856d,3013:952e25,3014:c97375,3015:d7a0a6,3016:a43c30,3017:c8545d,3018:c43e4a,3020:b81d13,3022:cc6955,3024:ff2a24,3026:ff2620,3027:a9263d,3028:c92b26,3031:a43338,3032:6e1c24,3033:a2392e,4001:836083,4002:8c3c4b,4003:c4608c,4004:641d39,4005:7b679a,4006:913073,4007:47243c,4008:874b83,4009:9d8592,4010:bb3e77,4011:716287,4012:6d6b7f,5000:384e6f,5001:1d4c64,5002:1e367b,5003:263855,5004:1a1e28,5005:005187,5007:426a8c,5008:2d3a44,5009:2d5e78,5010:004e7c,5011:1e2b3d,5012:2e88b6,5013:223053,5014:687c96,5015:0b7bb0,5017:005a8c,5018:1b8b8c,5019:0f5d84,5020:00414b,5021:007577,5022:2b2c5a,5023:4a688d,5024:6792ac,5025:2c697c,5026:1b2f52,6000:3b7460,6001:316834,6002:2d5a27,6003:4e533b,6004:084442,6005:114232,6006:3b392e,6007:2a3222,6008:36342a,6009:27362a,6010:486f38,6011:697d58,6012:303d3a,6013:7a765a,6014:464135,6015:3c3d36,6016:006a4c,6017:53803f,6018:599a39,6019:b7ceac,6020:36422f,6021:879a77,6022:393327,6024:008450,6025:5a6e3b,6026:005f4e,6027:80bab5,6028:305442,6029:00703c,6032:1c8051,6033:48877f,6034:7cadac,6035:134d24,6036:07584b,6037:008c27,6038:00b612,7000:7b888e,7001:8e969d,7002:7f7863,7003:787769,7004:9b9b9b,7005:6b6e6b,7006:756a5e,7008:725f3c,7009:5c6058,7010:585c56,7011:53595d,7012:585d5e,7013:565044,7015:505359,7016:383e42,7021:303234,7022:4c4a44,7023:7f8076,7024:46494f,7026:384345,7030:918e85,7031:5d686d,7032:b4b0a1,7033:7e8274,7034:90886f,7035:c5c7c4,7036:979392,7037:7a7b7a,7038:afb1a9,7039:6a665e,7040:989ea1,7042:8e9291,7043:4f5250,7044:b6b3a8,7045:8e9295,7046:7f868a,7047:c8c8c7,7048:807b73,8000:866a3e,8001:99632b,8002:774d3e,8003:7c4b27,8004:8a4931,8007:6d462b,8008:6f4a25,8011:583827,8012:64332b,8014:483526,8015:5d2f27,8016:4b2b20,8017:432f29,8019:3d3635,8022:1a1719,8023:a05729,8024:765038,8025:735847,8028:4f3a2a,8029:7d4031,9001:e9e0d2,9002:d7d5cb,9003:ecece7,9004:2b2b2c,9005:0e0e10,9006:a1a1a0,9007:878581,9010:f1ece1,9011:27292b,9012:fffde6,9016:f1f0ea,9017:2a292a,9018:c8cbc4,9022:858583,9023:797b7a'.split(',').map(x => { const [k, v] = x.split(':'); return [k, '#' + v]; }));
    const FAMS = [['1', 'Yellow & beige', '1003'], ['2', 'Orange', '2004'], ['3', 'Red', '3020'], ['4', 'Violet', '4006'], ['5', 'Blue', '5015'], ['6', 'Green', '6018'], ['7', 'Grey', '7037'], ['8', 'Brown', '8011'], ['9', 'White & black', '']];
    // nearest RAL to any colour: smallest distance in CIE Lab (as options-demo.js)
    const lab = hex => {
      const c = [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16) / 255).map(v => v > .04045 ? ((v + .055) / 1.055) ** 2.4 : v / 12.92);
      const f = t => t > .008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116;
      const [x, yy, z] = [[.4124, .3576, .1805, .95047], [.2126, .7152, .0722, 1], [.0193, .1192, .9505, 1.08883]].map(r => f((r[0] * c[0] + r[1] * c[1] + r[2] * c[2]) / r[3]));
      return [116 * yy - 16, 500 * (x - yy), 200 * (yy - z)];
    };
    let labs;
    const nearRal = hex => {
      labs = labs || Object.entries(RAL).map(([k, h]) => [k, lab(h)]);
      const p = lab(hex); let best = '', d = Infinity;
      labs.forEach(([k, q]) => { const e = (p[0] - q[0]) ** 2 + (p[1] - q[1]) ** 2 + (p[2] - q[2]) ** 2; if (e < d) { d = e; best = k; } });
      return best;
    };
    const ralPicker = input => {
      const fams = el('div', 'cfg-ral-fams'), grid = el('div', 'cfg-ral-sw'), any = el('input');
      any.type = 'color'; any.value = RAL['7016']; any.setAttribute('aria-label', 'Any colour');
      fams.setAttribute('role', 'group'); fams.setAttribute('aria-label', 'RAL colour families');
      const anyL = el('label', 'cfg-ral-any'); anyL.append(any, el('span', 'label', 'Any colour'));
      const box = el('div', 'cfg-ral ymq-ral'); box.append(fams, grid, el('div', 'cfg-ral-row'));
      $('.cfg-ral-row', box).append(anyL);
      let fam = '';
      const mark = () => $$('button', grid).forEach(b => b.setAttribute('aria-pressed', b.dataset.code === input.value.trim()));
      const showFam = f => {
        if (f === fam) return;
        fam = f;
        $$('button', fams).forEach(b => b.setAttribute('aria-pressed', b.dataset.fam === f));
        grid.replaceChildren(...Object.keys(RAL).filter(k => k[0] === f).map(k => {
          const b = el('button', 'cfg-ralb');
          b.type = 'button'; b.dataset.code = k; b.title = 'RAL ' + k; b.setAttribute('aria-label', 'RAL ' + k); b.style.background = RAL[k];
          b.addEventListener('click', () => pick(k));
          return b;
        }));
        mark();
      };
      const pick = c => {
        input.value = c;
        ['input', 'change', 'blur'].forEach(t => input.dispatchEvent(new Event(t, { bubbles: true })));
        sync();
      };
      const sync = () => { const c = input.value.trim(); if (RAL[c]) { any.value = RAL[c]; showFam(c[0]); } mark(); };
      FAMS.forEach(([f, name, c]) => {
        const b = el('button');
        b.type = 'button'; b.dataset.fam = f; b.title = name; b.setAttribute('aria-label', name);
        b.style.background = c ? RAL[c] : 'linear-gradient(135deg, ' + RAL['9010'] + ' 50%, ' + RAL['9005'] + ' 50%)';
        b.addEventListener('click', () => showFam(f));
        fams.append(b);
      });
      any.addEventListener('input', () => pick(nearRal(any.value)));
      input.addEventListener('input', sync);
      input.inputMode = 'numeric';
      showFam('7'); sync();
      return box;
    };
    const ral = y => $$('.ymq-options-box', y).forEach(box => {
      const i = $('.ymq-option-text-input-wrapper input', box);
      if (!i || box.dataset.ral || !/\bral\b/i.test((box.getAttribute('ymq-option-label') || '') + ' ' + i.placeholder)) return;
      box.dataset.ral = '1'; box.classList.add('ymq-join');
      $('.ymq-option-text-input-wrapper', box).before(ralPicker(i));
    });
    // One step per choice: a RAL field and a switch without a title ("All Ral options") join the step above them
    // (base.css .ymq-join). Never move YMQ's boxes: YMQ builds the sku in DOM order (tested: moving the RAL field
    // turned AVL-OFC-7016-R-… into AVL-OFC-R-7016-…).
    const join = y => $$('.ymq-options-box', y).forEach(b => { if ($('.ymq-option-switch', b) && !$('.ymq-option-title', b)) b.classList.add('ymq-join'); });
    const place = () => {
      const y = $('ymq-option', form);
      if (!y) return false;
      if (!y.dataset.skinned) {
        y.dataset.skinned = '1';
        buy.classList.add('ymq-skin');
        const wrap = document.createElement('div');
        wrap.className = 'ymq-wrap';
        slot.before(wrap); wrap.append(y);
      }
      unfilter(y); rows(y); ral(y); join(y); clip(y); fold(y);
      return true;
    };
    // YMQ renders after page load: wait for it (and for late option boxes), give up after 20 s
    place();
    const mo = new MutationObserver(place);
    mo.observe(form, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 20000);
    /* YMQ loads every swatch photo full size (1000 px, ~450 KB) to show it at 40 px: 30+ MB per chair page.
       Ask Shopify's CDN for 120 px instead (~10 KB each). pdp-3d.js asks for its own larger copy for the 3D fabric texture (width=600). */
    const small = () => $$('img.ymq-option-swatches-image:not([data-small])', form).forEach(img => {
      img.dataset.small = '1';
      const u = img.getAttribute('src') || '';
      if (/\/(s\/files|cdn\/shop\/files)\//.test(u) && !/[?&]width=/.test(u)) img.src = u + (u.includes('?') ? '&' : '?') + 'width=120';
    });
    small();
    new MutationObserver(small).observe(form, { childList: true, subtree: true });
  });

  /* ---- collection pages: split the full grid into pages (cells; a wide or tall tile = 2) ---- */
  $$('[data-pager]').forEach(async g => {
    const nav = g.closest('.shopify-section, main')?.querySelector('[data-pager-nav]');
    /* more than 250 products: fetch the next chunk(s) and append their tiles */
    let more = nav && nav.dataset.more, guard = 0;
    while (more && guard++ < 8) {
      try {
        const html = await (await fetch(more)).text(), doc = new DOMParser().parseFromString(html, 'text/html');
        const g2 = doc.querySelector('[data-pager]'); if (!g2) break;
        [...g2.children].forEach(t => { t.classList.remove('rv'); g.appendChild(document.adoptNode(t)); });
        more = doc.querySelector('[data-pager-nav]')?.dataset.more;
      } catch (e) { break; }
    }
    /* designer dropdown without a Shopify filter (Ivo's store): options from the tiles, ?designer= keeps the matching ones */
    const df = g.closest('.shopify-section, main')?.querySelector('[data-dfilter]');
    if (df) {
      const norm = s => (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
      // other spellings in the product field → one name (Theme settings → Productrasters, "spelling | name" per line)
      const alias = new Map((df.dataset.aliases || '').split('\n').map(l => l.split('|')).filter(p => p.length === 2 && p[1].trim()).map(([a, b]) => [norm(a), b.trim()]));
      const key = s => norm(alias.get(norm(s)) || s);
      // tidy Ivo's spelling for the label only ("Maarten baas", "LENSVELT DESIGN TEAM")
      const nice = s => (alias.get(norm(s)) || s).trim().replace(/\s+/g, ' ').split(' ').map(w => (/^[a-zà-ÿ]{3,}$/.test(w) && !/^(van|der|den|de|het)$/.test(w)) || /^[A-ZÀ-Þ]{4,}$/.test(w) ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w).join(' ');
      const names = new Map();
      $$('[data-designer]', g).forEach(t => { const k = key(t.dataset.designer); if (k && !names.has(k)) names.set(k, nice(t.dataset.designer)); });
      const u = new URL(location.href), want = key(u.searchParams.get('designer'));
      const panel = df.querySelector('.fpanel'), all = df.querySelector('[data-dfilter-all]');
      u.hash = ''; u.searchParams.delete('page'); u.searchParams.delete('designer'); all.href = u;
      [...names].sort((a, b) => a[1].localeCompare(b[1])).forEach(([k, label]) => {
        const a = document.createElement('a'); u.searchParams.set('designer', label); a.href = u; a.textContent = label;
        if (k === want) { a.className = 'on'; a.setAttribute('aria-current', 'true'); all.classList.remove('on'); const v = df.querySelector('[data-dfilter-val]'); v.textContent = label; v.hidden = false; }
        panel.appendChild(a);
      });
      df.hidden = names.size < 2;
      if (want) [...g.children].forEach(t => {
        const inner = t.dataset.designer !== undefined ? [t] : $$('[data-designer]', t);
        const hits = inner.filter(x => key(x.dataset.designer) === want);
        if (!hits.length) return t.remove();
        inner.forEach(x => { if (!hits.includes(x)) x.remove(); });
        t.classList.remove('wide', 'tall', 'big'); // a filtered list is a plain grid
      });
    }
    const per = +g.dataset.pager || 24, tiles = [...g.children];
    const size = t => t.classList.contains('big') ? 4 : (t.classList.contains('wide') || t.classList.contains('tall') || t.classList.contains('pstack') ? 2 : 1);
    const pages = []; let cur = [], cells = 0;
    const cols = +g.style.getPropertyValue('--cols') || 4;
    for (let i = 0; i < tiles.length; i++) {
      let t = tiles[i], w = size(t);
      /* a tall tile in a page's last row has no second row to grow into: it becomes a normal tile (.flat),
         so its caption lines up with the row and no empty cell is left beside it */
      if (t.classList.contains('tall') && cells >= per - cols) { t.classList.add('flat'); w = 1; }
      if (cells + w > per && cur.length) {
        // a double tile no longer fits: pull the next single tile forward so the page still ends on a full row
        const j = per - cells === 1 ? tiles.findIndex((x, k) => k > i && size(x) === 1) : -1;
        if (j > 0) { const [x] = tiles.splice(j, 1); tiles.splice(i, 0, x); g.insertBefore(x, t); t = x; w = 1; }
        else { pages.push(cur); cur = []; cells = 0; }
      }
      cur.push(t); cells += w;
    }
    if (cur.length) pages.push(cur);
    $$('[data-pcount]').forEach(c => { const n = tiles.reduce((s, t) => s + (t.classList.contains('pstack') ? t.querySelectorAll('.tile').length : (t.matches('.tile') ? 1 : 0)), 0); c.textContent = n + ' ' + (n === 1 && c.dataset.wordOne || c.dataset.word); });
    /* phone (2 columns): wide and big tiles take a whole row, so a page can end on one product.
       With an odd number of half-width tiles, the first one goes full width (only below 900px, see base.css) */
    pages.forEach(pg => {
      const singles = pg.flatMap(t => t.classList.contains('pstack') ? [...t.querySelectorAll('.tile')] : (t.classList.contains('wide') || t.classList.contains('big') ? [] : [t]));
      if (singles.length % 2) singles[0].classList.add('m-wide');
    });
    /* the search field in the filter bar: shows the products on this page whose name or designer holds every typed word,
       instead of a second trip to the search page (Ivo 02-11); empty again = the pages as before */
    const gs = g.closest('.shopify-section, main')?.querySelector('[data-gsearch]');
    let restore = () => tiles.forEach(t => { t.hidden = false; });
    if (gs) {
      const gq = $('input[name="q"]', gs), pmore = g.closest('.shopify-section, main')?.querySelector('[data-pager-more]');
      gs.addEventListener('submit', e => e.preventDefault());
      gq.addEventListener('input', () => {
        const words = gq.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
        $$('.q-off', g).forEach(x => x.classList.remove('q-off'));
        g.classList.toggle('searching', !!words.length);
        if (pmore && words.length) pmore.hidden = true;
        if (!words.length) return restore();
        tiles.forEach(t => {
          const inner = t.matches('.tile') ? [t] : $$('.tile', t);
          const hits = inner.filter(x => { const k = (($('h3', x) || x).textContent + ' ' + (x.dataset.designer || '')).toLowerCase(); return words.every(w => k.includes(w)); });
          t.hidden = false;
          if (!hits.length) t.classList.add('q-off');
          else inner.forEach(x => { if (!hits.includes(x)) x.classList.add('q-off'); });
        });
      });
    }
    if (pages.length < 2 || !nav) return;
    const prev = nav.querySelector('[data-prev]'), next = nav.querySelector('[data-next]'), cnt = nav.querySelector('[data-count]');
    const fromHash = () => { const m = location.hash.match(/^#p(\d+)$/); return m ? Math.min(Math.max(+m[1], 1), pages.length) : 1; };
    /* pages first..last are on screen. Only Load more (Stijn 02-11): it adds the next page under the current one.
       The page-number nav stays hidden; it only carries data-more (the next 250 to fetch). An old #pN link opens pages 1..N. */
    const moreBox = g.closest('.shopify-section, main')?.querySelector('[data-pager-more]');
    let first = 1, last = 1;
    const show = (n, scroll, upTo) => {
      first = n; last = upTo || n;
      pages.forEach((pg, i) => pg.forEach(t => { t.hidden = i < first - 1 || i > last - 1; }));
      cnt.textContent = (last > first ? first + '–' + last : first) + ' / ' + pages.length;
      prev.style.visibility = first > 1 ? '' : 'hidden'; next.style.visibility = last < pages.length ? '' : 'hidden';
      prev.href = '#p' + (first - 1); next.href = '#p' + (last + 1);
      if (moreBox) moreBox.hidden = last >= pages.length;
      if (scroll) g.scrollIntoView({ block: 'start' });
    };
    /* back from a product: the pages opened with Load more and the scroll position are kept in this history entry,
       so the grid opens as it was and the browser does not land on the footer of a one-page grid */
    const keep = () => history.replaceState({ ...(history.state || {}), pager: last, y: scrollY }, '');
    moreBox?.querySelector('button').addEventListener('click', () => { show(first, false, last + 1); keep(); });
    document.addEventListener('click', e => { if (e.target.closest('a[href]')) keep(); });
    restore = () => show(first, false, last);
    const st = history.state || {};
    show(1, false, st.pager ? Math.min(st.pager, pages.length) : fromHash());
    if (st.y) { history.scrollRestoration = 'manual'; scrollTo({ top: st.y, behavior: 'instant' }); }
  });

  /* ---- collection filter bar: one dropdown open at a time; category and sort links keep the other filters ---- */
  const drops = $$('[data-fdrop]');
  drops.forEach(d => d.addEventListener('toggle', () => { if (d.open) drops.forEach(o => o !== d && (o.open = false)); }));
  document.addEventListener('click', e => { if (!e.target.closest('[data-fdrop]')) drops.forEach(d => (d.open = false)); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') drops.forEach(d => (d.open = false)); });
  $$('a[data-keepq]').forEach(a => { const u = new URL(location.href); u.searchParams.delete('page'); a.href = a.href.split('?')[0] + u.search; });
  $$('a[data-sort]').forEach(a => { const u = new URL(location.href); u.searchParams.set('sort_by', a.dataset.sort); u.searchParams.delete('page'); u.hash = ''; a.href = u; });

  /* ---- professionals journeys: on phone the list folds behind a bar (sections/pro-journeys) ---- */
  $$('[data-pj-more]').forEach(b => b.addEventListener('click', () => { const open = b.closest('.pj-body').classList.toggle('open'); b.textContent = open ? b.dataset.less : b.dataset.more; b.setAttribute('aria-expanded', open); }));

  /* ---- product options: "Show all" bar for options with more than 5 choices (sections/main-product) ---- */
  $$('[data-opts-more]').forEach(b => b.addEventListener('click', () => {
    const row = b.previousElementSibling, open = row.classList.toggle('open');
    b.textContent = open ? b.dataset.less : b.dataset.more; b.setAttribute('aria-expanded', open);
    if (!open) b.closest('.opts').scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }));

  /* ---- product specifications from assets/specs.json (copy of lensvelt.nl) when the store has no metafield ---- */
  $$('[data-specs]').forEach(async box => {
    try {
      const data = await (await fetch(box.dataset.specsSrc)).json();
      const rows = data[box.dataset.specs];
      if (!rows || !rows.length) return;
      const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      // "; " in a value = a new line (e.g. Width / Depth / Height under Measurements)
      const val = t => esc(t).split('; ').join('<br>');
      box.innerHTML = '<dl class="specs">' + rows.map(r => { const i = r.indexOf(':'); return i > 0 ? `<div><dt>${esc(r.slice(0, i).trim())}</dt><dd>${val(r.slice(i + 1).trim())}</dd></div>` : `<div><dd>${val(r)}</dd></div>`; }).join('') + '</dl>';
      const fb = box.parentElement && $('[data-specs-fallback]', box.parentElement); fb && fb.remove();
    } catch (e) {}
  });

  /* ---- product price follows the options: YMQ keeps its surcharge in properties[_YmqItemPrice] (euros) and only charges it
     at checkout, so the page adds it to the bare variant price itself. Money is formatted like the price Liquid rendered. ---- */
  $$('.pdp-buy form[action*="/cart/add"]').forEach(form => {
    const el = $('[data-price][data-base]', form);
    if (!el || el.dataset.onRequest) return;
    const sample = el.textContent.trim(), m = sample.match(/^(\D*)([\d.,\s]+?)(\D*)$/);
    if (!m) return;
    const digits = m[2], dec = (digits.match(/([.,])\d{1,2}$/) || [])[1] || '', thou = (digits.match(/[.,\s]/g) || []).find(c => c !== dec) || '';
    const money = cents => {
      const n = Math.round(cents), whole = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, thou), frac = String(n % 100).padStart(2, '0');
      return m[1] + whole + (dec ? dec + frac : '') + m[3];
    };
    // YMQ's surcharge is excl. VAT; data-vat (from the theme setting) brings it in line with the price shown
    const vat = parseFloat(el.dataset.vat) || 1;
    let t;
    const paint = () => {
      const add = Math.round(parseFloat(new FormData(form).get('properties[_YmqItemPrice]') || 0) * 100 * vat) || 0;
      const s = money(+el.dataset.base + add);
      // only write when it changes: a write is a mutation, and the observer below would call paint again, forever
      if (el.textContent !== s) el.textContent = s;
    };
    const soon = () => { clearTimeout(t); t = setTimeout(paint, 150); };
    form.addEventListener('change', soon); form.addEventListener('input', soon);
    document.addEventListener('cfg:change', soon); document.addEventListener('price:base', soon);
    new MutationObserver(soon).observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['value'] });
    paint();

    // YMQ prints its surcharges excl. VAT: in its own price spans (<span data-ymq-money="65">€65,00</span>) and in the
    // "(+€65,00)" labels of the option rows the theme builds from YMQ's dropdowns (.ymq-option-value-price). Show them
    // incl. VAT too: only the text changes, YMQ's data and attributes stay as they are. The whole buy-box is watched,
    // since YMQ renders after this script and the rows are built then as well.
    if (vat !== 1) {
      const root = form.closest('.pdp-buy') || form, seen = new WeakMap();
      const num = c => { const s = money(c); return s.slice(m[1].length, s.length - m[3].length); };
      const toCents = s => { const d = (s.match(/([.,])\d{1,2}$/) || [])[1]; return Math.round(parseFloat((d ? s.replace(new RegExp('[^\\d' + d + ']', 'g'), '').replace(d, '.') : s.replace(/\D/g, '')) || 0) * 100); };
      const fix = () => $$('[data-ymq-money], .ymq-option-value-price', root).forEach(sp => {
        const txt = sp.textContent;
        if (sp.children.length || seen.get(sp) === txt) return;
        const raw = txt.match(/\d[\d.,]*/);
        if (!raw) return;
        const c = sp.dataset.ymqMoney ? Math.round(parseFloat(sp.dataset.ymqMoney) * 100) : toCents(raw[0]);
        if (!(c > 0)) return;
        const out = txt.replace(raw[0], num(c * vat));
        sp.textContent = out; seen.set(sp, out);
      });
      const soonFix = () => { clearTimeout(fix.t); fix.t = setTimeout(fix, 200); };
      // the price span's own repaints are not a reason to look again
      new MutationObserver(ms => { if (ms.some(r => r.target !== el && !el.contains(r.target))) soonFix(); }).observe(root, { subtree: true, childList: true, characterData: true });
      addEventListener('load', soonFix);
      fix();
    }
  });

  /* ---- product gallery arrows ---- */
  $$('[data-gallery]').forEach(g => {
    const track = $('.slides', g);
    $$('[data-dir]', g).forEach(b => b.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * Number(b.dataset.dir), behavior: 'smooth' })));
  });

  /* ---- product: variant selection ---- */
  $$('[data-product]').forEach(root => {
    const dataEl = $('script[type="application/json"][data-variants]', root);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const groups = $$('[data-option]', root);
    const selects = groups.map(g => ({ get value() { const r = $('input:checked', g); return r ? r.value : (g.value || ''); }, el: g }));
    const idInput = $('input[name="id"]', root);
    const priceEl = $('[data-price]', root);
    const addBtn = $('[data-add-btn]', root);
    const quoteVariant = $('[data-quote-variant]', root);
    const update = () => {
      const chosen = selects.map(s => s.value);
      groups.forEach((g, i) => { const lab = $('[data-option-value]', g); if (lab) lab.textContent = chosen[i]; });
      // grey out values that give no available variant with the other choices
      groups.forEach((g, i) => $$('input[type=radio]', g).forEach(r => {
        const test = chosen.slice(); test[i] = r.value;
        const m = variants.find(x => x.options.every((o, k) => o === test[k]));
        r.closest('.opt-chip').classList.toggle('na', !m || !m.available);
      }));
      const v = variants.find(x => x.options.every((o, i) => o === chosen[i]));
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl && !priceEl.dataset.onRequest) { priceEl.dataset.base = v.cents; priceEl.textContent = v.price; document.dispatchEvent(new CustomEvent('price:base')); }
      if (addBtn) { addBtn.disabled = !v.available; addBtn.querySelector('span').textContent = v.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout; }
      if (quoteVariant) quoteVariant.value = v.title;
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    groups.forEach(g => g.addEventListener('change', update));
    update();
  });

  /* ---- quote form: stay open after a submit (success or error) ---- */
  $$('.quote').forEach(q => { if ($('.form-msg', q)) { q.classList.add('open'); q.scrollIntoView({ block: 'center' }); } });

  /* ---- quote form toggle ---- */
  $$('[data-quote-toggle]').forEach(b => b.addEventListener('click', () => {
    const q = document.getElementById(b.getAttribute('aria-controls'));
    if (!q) return;
    const o = !q.classList.contains('open');
    q.classList.toggle('open', o);
    b.setAttribute('aria-expanded', o);
    if (o) { const f = $('input, select, textarea', q); f && f.focus(); }
  }));

  /* ---- hero wordmark (homepage): first screen = LENSVELT on white above the film, both
          fully in view (the film is never cropped: the word starts smaller when needed),
          menu bar hidden. Scrolling down, the word stays put on screen and grows to full
          size while the film slides up past it, so it lands in its own spot under the film;
          then the menu bar fades in and it all stays that way. Transforms only, the layout
          never changes, so nothing jumps. ---- */
  /* hero film on a phone: Shopify only lists the 1080p mp4 for a 4K upload (hero-wordmark.liquid); take the 720p
     file from its HLS list ("…HD-720p.4.5Mbps.hls.99752959_.m3u8" → "…HD-720p-4.5Mbps-99752959.mp4"), else the full one */
  const hv = $('.hero video[data-hls]');
  if (hv && matchMedia('(max-width: 899px)').matches) {
    const base = hv.dataset.hls.replace(/[^/]*$/, ''), full = () => { hv.src = hv.dataset.full; hv.play().catch(() => {}); };
    fetch(hv.dataset.hls).then(r => r.text()).then(t => {
      const names = t.split('\n').filter(l => /\.hls\.\d+_\.m3u8$/.test(l));
      const pick = names.map(n => ({ n, h: +(n.match(/-(\d+)p\./) || [0, 0])[1] })).filter(x => x.h && x.h <= 720).sort((a, b) => b.h - a.h)[0];
      const mp4 = pick && pick.n.replace(/\.(HD|SD)-(\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8$/, '.$1-$2-$3-$4.mp4');
      if (!mp4 || mp4 === pick.n) return full();
      hv.src = base + mp4 + '?v=0'; hv.play().catch(() => {});
    }).catch(full);
  }
  const heroWord = $('.hero .fitword'), heroMedia = $('.hero .hero-media'), hdrSec = $('.shopify-section.section-header') || $('.hdr');
  // only when the visitor arrives from outside (Google, a link, typed address); coming from a page
  // on the site itself (e.g. the logo) the homepage opens straight in its final state, menu bar visible
  const fromSite = (() => { try { return !!document.referrer && new URL(document.referrer).host === location.host; } catch (e) { return false; } })();
  if (heroWord && heroMedia && !fromSite && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.body.classList.add('hero-over');
    const box = heroWord.parentElement;
    let ticking = false, L = 1, s0 = 1, pw = 0, wH = 0, done = false;
    const measure = () => {
      L = Math.max(1, heroMedia.offsetHeight);                  // scroll distance = film height
      pw = parseFloat(getComputedStyle(box).paddingTop);
      wH = heroWord.offsetHeight;
      // start size: word + film together fit the first screen (not smaller than 45 %)
      s0 = Math.min(1, Math.max(.45, (innerHeight - L - 2 * pw) / wH));
    };
    const update = () => {
      ticking = false;
      if (done) return;
      const y = Math.max(0, scrollY), p = Math.min(1, y / L);
      if (p >= 1) {
        done = true;
        heroWord.style.transform = heroMedia.style.transform = '';
        document.body.classList.add('hero-landed');
        hdrSec && hdrSec.classList.remove('hdr-off');
        return;
      }
      const sc = s0 + (1 - s0) * p;                              // grows to full size while it travels
      const room = 2 * pw + wH * s0;                            // white row above the film at the start
      heroMedia.style.transform = `translate3d(0, ${(room * (1 - p)).toFixed(1)}px, 0)`;
      heroWord.style.transform = `translate3d(0, ${(-L * (1 - p)).toFixed(1)}px, 0) scale(${sc.toFixed(4)})`;
      hdrSec && hdrSec.classList.add('hdr-off');
    };
    const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    addEventListener('scroll', req, { passive: true });
    addEventListener('resize', () => { if (!done) { measure(); req(); } });
    document.fonts && document.fonts.ready.then(() => { if (!done) { measure(); req(); } });
    measure(); update();
  }
  /* ---- projects: filter by sector + project pages that open over the overview ---- */
  /* an open project or story page scrolls on its own, over the page: the footer moves into it, and back on close */
  const ftr = $('.ftr'), ftrMark = document.createComment('footer');
  if (ftr) ftr.before(ftrMark);
  const carryFooter = d => { if (!ftr) return; if (d) d.append(ftr); else if (!$('.pdet.open')) ftrMark.after(ftr); };

  /* ---- footer reveal (base.css): a footer taller than the screen sticks until "since 1962" sits just under the header
     (the page edge then hides behind the header), after that everything scrolls on to the logo; a footer that fits sticks to the bottom ---- */
  const ftrWrap = $('.shopify-section-group-footer-group');
  if (ftrWrap) {
    /* the whole footer in one screen under the header: "since 1962" and the logo stay full width,
       only the white space between the parts shrinks (--fg) when it is too tall */
    const fitFtr = () => {
      if (!ftr || !ftrWrap.contains(ftr)) return;
      const h = $('.section-header'), avail = innerHeight - (h ? h.offsetHeight : 0);
      ftr.style.minHeight = '0px'; ftr.style.setProperty('--fg', 1);
      const u = innerWidth / 1280, gaps = 126 * u, over = ftr.offsetHeight - avail; // 40 + 22 + 40 + 24 units of white space
      const g = over > 0 ? Math.max(.15, 1 - over / gaps) : 1;
      // a phone's footer is much shorter than the screen: it keeps its own height there (no empty block).
      // on a wide but low-content screen (half a widescreen) the gap above the logo stops at the Figma's 130 units, not a full screen
      ftr.style.setProperty('--fg', g.toFixed(3));
      ftr.style.minHeight = innerWidth > 600 ? Math.min(avail, ftr.offsetHeight + 90 * u) + 'px' : '';
    };
    const stick = () => {
      const h = $('.section-header'), big = $('.ftr-big', ftrWrap);
      const pad = big ? Math.max(0, big.getBoundingClientRect().top - ftrWrap.getBoundingClientRect().top - 8) : 0;
      ftrWrap.style.setProperty('--ftr-stick', Math.min(0, innerHeight - ftrWrap.offsetHeight - (h ? h.offsetHeight : 0) + pad) + 'px');
    };
    document.documentElement.classList.add('ftr-reveal');
    // a phone's address bar folding in or out only changes the height a little: don't resize the footer for that while scrolling
    let lastW = 0, lastH = 0;
    const fitAll = force => {
      if (force !== true && innerWidth === lastW && Math.abs(innerHeight - lastH) < 150) return;
      lastW = innerWidth; lastH = innerHeight; fitFtr(); stick();
    };
    fitAll(true); addEventListener('resize', fitAll);
    document.fonts && document.fonts.ready.then(() => fitAll(true));
  }

  /* ---- projects archive: every project ever, from assets/archive.json; photos in Files as archive-[code]-[n].jpg ---- */
  const archive = root => {
    const list = $('[data-archive]', root), det = $('#archive-project', root);
    if (!list || !det) return null;
    const grid = $('[data-arch-grid]', list), q = $('[data-arch-q]', list), cnt = $('[data-arch-count]', list), none = $('[data-arch-none]', list), body = $('[data-arch-body]', det);
    const base = list.dataset.files, word = cnt.dataset.word || '';
    const esc = t => String(t || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const norm = t => String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const src = (h, n, w) => base + 'archive-' + h + '-' + n + '.jpg?width=' + w;
    const pic = (p, n, sizes, w) => '<img src="' + src(p.h, n, w) + '" srcset="' + [400, 800, 1200, 1800].map(x => src(p.h, n, x) + ' ' + x + 'w').join(', ') + '" sizes="' + sizes + '" loading="lazy" alt="' + esc(p.i[n - 1] || p.t) + '" onerror="this.remove()">';
    let data = null, loading = null, want = null, vis = [];
    // same lookup as snippets/product-url.liquid: "name | handle" per line
    const plinks = {};
    (list.dataset.plinks || '').split('\n').forEach(l => { const [k, h] = l.split('|').map(x => x.trim()); if (k && h) plinks[k.toLowerCase()] = h; });
    const purl = t => { const h = plinks[t.toLowerCase()]; return h ? (list.dataset.proot + '/products/' + h).replace('//', '/') : list.dataset.psearch + '?type=product&q=' + encodeURIComponent(t); };
    const filter = () => {
      if (!data) return;
      const words = norm(q.value).split(/\s+/).filter(Boolean);
      vis = [];
      $$('.parc-tile', grid).forEach((t, k) => { const on = words.every(w => t.dataset.k.includes(w)); t.hidden = !on; if (on) vis.push(data[k]); });
      cnt.textContent = vis.length + ' ' + (vis.length === 1 && cnt.dataset.wordOne || word);
      none.hidden = vis.length > 0;
    };
    const load = () => loading || (loading = fetch(list.dataset.archive).then(r => r.json()).then(j => {
      data = j;
      grid.innerHTML = data.map(p => '<a href="#archive-' + p.h + '" class="parc-tile" data-k="' + esc(norm([p.t, p.c, p.l, p.a, p.p].join(' '))) + '"><div class="ph-media">' + (p.i.length ? pic(p, 1, '(min-width: 750px) 25vw, 50vw', 600) : '') + '</div><div class="parc-cap"><h2>' + esc(p.t) + '</h2><span class="label muted">' + esc([p.c, p.l].filter(Boolean).join(' · ')) + '</span></div></a>').join('');
      filter();
      if (want) { const id = want; want = null; if (location.hash.slice(1) === id) route(id); }
    }));
    q.addEventListener('input', () => { filter(); list.dataset.keep = 0; list.scrollTop = 0; });
    const fill = p => {
      const order = vis.length && vis.includes(p) ? vis : data, k = order.indexOf(p), nx = order[(k + 1) % order.length];
      $('[data-arch-pos]', det).textContent = String(k + 1).padStart(2, '0') + ' / ' + String(order.length).padStart(2, '0');
      const nl = $('[data-arch-next]', det); nl.setAttribute('href', '#archive-' + nx.h); $('.nx-t', nl).textContent = nx.t;
      const facts = [['Architect', p.a], ['Location', p.l], ['Sector', p.c], ['Photography', p.ph]].filter(f => f[1]);
      // products as on the selected projects: a name from the Productlinks setting goes to that product, otherwise to search
      const prods = p.p ? '<div><dt class="label">Lensvelt in this project</dt><dd class="ptags">' + p.p.split(',').map(t => t.trim()).filter(Boolean).map(t => '<a href="' + esc(purl(t)) + '" class="ul">' + esc(t) + '</a>').join('<span class="muted"> · </span>') + '</dd></div>' : '';
      body.innerHTML =
        '<header class="pdet-head"><span class="label muted">' + esc([p.c, p.l].filter(Boolean).join(' · ')) + '</span><h1>' + esc(p.t) + '</h1></header>' +
        (p.cv ? '<div class="pdet-cover"><div class="ph-media" style="aspect-ratio: 16 / 9">' + pic(p, 1, '100vw', 1800) + '</div></div>' : '') +
        '<div class="pdet-body"><dl class="pfacts">' + facts.map(f => '<div><dt class="label">' + f[0] + '</dt><dd>' + esc(f[1]) + '</dd></div>').join('') + prods + '</dl>' +
        '<div class="pdet-text">' + p.x.map(t => '<p>' + esc(t) + '</p>').join('') + '</div></div>' +
        // a big cover only when the photo is large enough (cv); otherwise every photo sits in the gallery
        (p.i.length > (p.cv ? 1 : 0) ? '<div class="parc-gal">' + p.i.map((c, n) => (n === 0 && p.cv) || c === null ? '' : '<figure>' + pic(p, n + 1, '(min-width: 750px) 50vw, 100vw', 1200) + '<figcaption class="pcap label"><span>' + esc(c) + '</span></figcaption></figure>').join('') + '</div>' : '') +
        '<a href="#archive-' + nx.h + '" class="pnext"><span class="label muted">' + esc($('.nx-s', nl).textContent) + '</span><span class="t">' + esc(nx.t) + ' <span class="arr">→</span></span></a>';
      det.dataset.keep = 0;
    };
    const route = id => {
      load();
      if (id === 'archive') { if (!det.classList.contains('open')) list.dataset.keep = 0; return list; }
      list.dataset.keep = list.classList.contains('open') ? list.scrollTop : (list.dataset.keep || 0);
      if (!data) { want = id; return det; }
      const p = data.find(x => 'archive-' + x.h === id);
      if (!p) return list;
      fill(p);
      return det;
    };
    return { route, search: v => { q.value = v; list.dataset.keep = 0; load().then(filter); } };
  };

  $$('[data-projects]').forEach(root => {
    const btns = $$('[data-pfilter]', root), items = $$('.pstrip[data-cat]', root);
    /* sector buttons and the search field work together: a project shows when it is in the sector and holds every typed word */
    let cat = 'all', words = [];
    const apply = () => {
      const c = words.length ? 'search' : cat;
      items.forEach(el => { el.hidden = (cat !== 'all' && el.dataset.cat !== cat) || !words.every(w => (el.dataset.k || '').includes(w)); });
      // re-size the visible cells so every row of 6 columns is full (no grey gaps)
      const vis = items.filter(el => !el.hidden);
      // keep the left/right/left rhythm over the visible projects only
      vis.forEach((el, n) => el.classList.toggle('flip', n % 2 === 1));
      const set = (el, size) => { el.classList.remove('feature', 'half', 'third'); el.classList.add(size); };
      if (c === 'all') { vis.forEach(el => set(el, el.dataset.size || 'half')); return; }
      let i = 0;
      while (i < vis.length) {
        const r = vis.length - i;
        let plan;
        if (r >= 6) plan = ['feature', 'half', 'half', 'third', 'third', 'third'];
        else if (r === 5) plan = ['half', 'half', 'third', 'third', 'third'];
        else if (r === 4) plan = ['half', 'half', 'half', 'half'];
        else if (r === 3) plan = ['third', 'third', 'third'];
        else if (r === 2) plan = ['half', 'half'];
        else plan = ['feature'];
        plan.forEach(sz => set(vis[i++], sz));
      }
    };
    btns.forEach(b => b.addEventListener('click', () => {
      cat = b.dataset.pfilter;
      btns.forEach(x => x.classList.toggle('on', x === b));
      apply();
    }));
    const want = new URLSearchParams(location.search).get('sector');
    if (want) { const b = btns.find(x => x.dataset.pfilter.toLowerCase() === want.toLowerCase()); b && b.click(); }
    const dets = $$('[data-pdet]', root);
    const arch = archive(root);
    let lastStrip = null;
    const show = () => {
      const id = decodeURIComponent(location.hash.slice(1));
      let d = id.startsWith('project-') ? document.getElementById(id) : null;
      if (!d && arch && (id === 'archive' || id.startsWith('archive-'))) d = arch.route(id);
      dets.forEach(x => { const on = x === d; x.classList.toggle('open', on); x.setAttribute('aria-hidden', !on); });
      document.documentElement.classList.toggle('pdet-on', !!d);
      carryFooter(d);
      requestAnimationFrame(() => document.documentElement.classList.remove('pdet-direct'));
      if (d) {
        d.scrollTop = +(d.dataset.keep || 0);
        if (id.startsWith('project-')) lastStrip = document.getElementById('p-' + id.slice(8));
        else if (!lastStrip) lastStrip = $('#parchive', root);
      }
      else if (lastStrip) { lastStrip.scrollIntoView({ block: 'center' }); lastStrip = null; }
    };
    const go = href => { history.pushState(null, '', href); show(); };
    root.addEventListener('click', e => {
      const a = e.target.closest('a[href^="#project-"], a[href^="#archive"], a[data-pclose]');
      if (a) { e.preventDefault(); go(a.getAttribute('href')); }
    });
    // the bar next to the filter: the button and the search field both open the archive
    const archForm = $('[data-arch-open]', root);
    if (archForm && arch) {
      const fq = $('input', archForm), more = $('[data-psearch-more]', root);
      archForm.addEventListener('submit', e => { e.preventDefault(); arch.search(fq.value); go('#archive'); });
      // typing filters the projects on this page; the line under it searches on in the archive
      fq.addEventListener('input', () => {
        const v = fq.value.trim();
        words = v.toLowerCase().split(/\s+/).filter(Boolean);
        apply();
        if (!more) return;
        more.hidden = !words.length;
        $('[data-psearch-none]', more).textContent = words.length && items.every(el => el.hidden) ? more.dataset.none : '';
        const a = $('[data-psearch-arch]', more);
        a.textContent = more.dataset.arch.replace('%q', v);
        a.onclick = e => { e.preventDefault(); arch.search(v); go('#archive'); };
      });
    }
    addEventListener('popstate', show);
    addEventListener('hashchange', show);
    addEventListener('keydown', e => { if (e.key === 'Escape' && document.documentElement.classList.contains('pdet-on')) go('#' + (lastStrip ? lastStrip.id : '')); });
    show();
  });

  /* ---- stories: filter by kind + story pages that open over the overview (same as projects) ---- */
  $$('[data-stories]').forEach(root => {
    const btns = $$('[data-sfilter]', root), items = $$('.pstrip[data-cat]', root);
    btns.forEach(b => b.addEventListener('click', () => {
      const c = b.dataset.sfilter;
      btns.forEach(x => x.classList.toggle('on', x === b));
      items.forEach(el => { el.hidden = c !== 'all' && el.dataset.cat !== c; });
      // keep the left/right/left rhythm over the visible stories only
      items.filter(el => !el.hidden).forEach((el, n) => el.classList.toggle('flip', n % 2 === 1));
    }));
    const want = new URLSearchParams(location.search).get('kind');
    if (want) { const b = btns.find(x => x.dataset.sfilter.toLowerCase() === want.toLowerCase()); b && b.click(); }
    const dets = $$('[data-sdet]', root);
    let lastCell = null;
    const show = () => {
      const id = decodeURIComponent(location.hash.slice(1));
      const d = id.startsWith('story-') ? document.getElementById(id) : null;
      dets.forEach(x => { const on = x === d; x.classList.toggle('open', on); x.setAttribute('aria-hidden', !on); });
      document.documentElement.classList.toggle('pdet-on', !!d);
      carryFooter(d);
      requestAnimationFrame(() => document.documentElement.classList.remove('pdet-direct'));
      if (d) { d.scrollTop = 0; watch(d); lastCell = document.getElementById('s-' + id.slice(6)); }
      else if (lastCell) { lastCell.scrollIntoView({ block: 'center' }); lastCell = null; }
    };
    const go = href => { history.pushState(null, '', href); show(); };
    root.addEventListener('click', e => {
      const a = e.target.closest('a[href^="#story-"], a[data-sclose]');
      if (a) { e.preventDefault(); go(a.getAttribute('href')); }
    });
    addEventListener('popstate', show);
    addEventListener('hashchange', show);
    addEventListener('keydown', e => { if (e.key === 'Escape' && document.documentElement.classList.contains('pdet-on') && root.querySelector('.sdet.open')) go('#' + (lastCell ? lastCell.id : '')); });
    show();
  });

  /* ---- cart: quantities update automatically (no Update button) ---- */
  $$('[data-cart-form]').forEach(f => {
    let t;
    $$('[data-cart-qty]', f).forEach(i => i.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => f.submit(), 350); }));
  });

  /* ---- quote form: open with a preset request type (samples, CAD/BIM, ...) ---- */
  $$('[data-quote-topic]').forEach(b => b.addEventListener('click', () => {
    const q = document.getElementById(b.getAttribute('aria-controls'));
    if (!q) return;
    const sel = $('[data-quote-type]', q);
    if (sel) { sel.value = b.dataset.quoteTopic; sel.dispatchEvent(new Event('change')); }
    q.classList.add('open');
    q.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    const f = $('input:not([type=hidden]), textarea', q); f && f.focus({ preventScroll: true });
  }));

  /* ---- quote form on product page: copy the chosen configuration (any option app: YMQ, demo) into the request ---- */
  $$('[data-quote-config]').forEach(field => {
    const qf = field.closest('form');
    const pf = document.querySelector('form[action*="/cart/add"]');
    if (!qf || !pf) return;
    const fill = () => {
      const lines = [];
      new FormData(pf).forEach((v, k) => { const m = k.match(/^properties\[(.+)\]$/); if (m && !m[1].startsWith('_') && String(v).trim()) lines.push(m[1].replace(/:$/, '') + ': ' + v); });
      field.value = lines.join(' | ');
    };
    qf.addEventListener('submit', fill, true);
    document.addEventListener('cfg:change', fill);
  });

  /* ---- quote form: the fields follow the request type; ?topic=dealer (samples, cad, advice ...) preselects ---- */
  const topicParam = (new URLSearchParams(location.search).get('topic') || '').toLowerCase();
  const topicMap = { dealer: 'Dealer', samples: 'Stalen', cad: 'CAD-BIM', advice: 'Projectadvies', quote: 'Offerte', contact: 'Vraag', question: 'Vraag' };
  $$('[data-quote-type]').forEach(sel => {
    const q = sel.closest('.quote');
    // show only the fields of the chosen request type; hidden fields are disabled so they are not sent
    const sync = () => {
      q.dataset.type = sel.value;
      $$('[data-q]', q).forEach(e => {
        const on = e.dataset.q.split(' ').includes(sel.value);
        e.hidden = !on;
        $$('input, select, textarea', e).forEach(f => { f.disabled = !on; });
      });
    };
    sel.addEventListener('change', sync);
    if (topicMap[topicParam]) { sel.value = topicMap[topicParam]; q.classList.add('open'); }
    const pre = new URLSearchParams(location.search).get('msg'), body = $('textarea[name="contact[body]"]', q);
    if (pre && body && !body.value) body.value = pre.split('; ').join('\n'); // e.g. a look's products, from Shop the look
    sync();
  });

  /* ---- shop the look: a dot opens its product card ---- */
  $$('[data-look]').forEach(root => {
    const dots = $$('[data-look-dot]', root);
    const close = () => dots.forEach(d => { d.setAttribute('aria-expanded', 'false'); d.classList.remove('on'); const c = document.getElementById(d.getAttribute('aria-controls')); if (c) c.hidden = true; });
    dots.forEach(d => d.addEventListener('click', e => {
      e.stopPropagation();
      const was = d.classList.contains('on');
      close();
      if (was) return;
      d.classList.add('on'); d.setAttribute('aria-expanded', 'true');
      const c = document.getElementById(d.getAttribute('aria-controls')); if (c) c.hidden = false;
    }));
    document.addEventListener('click', e => { if (!e.target.closest('[data-look-card]')) close(); });
    addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  });

  /* ---- designers page: product slider per designer ---- */
  $$('[data-dcar]').forEach(c => {
    const t = $('[data-dcar-track]', c), prev = $('[data-dcar-prev]', c), next = $('[data-dcar-next]', c), cnt = $('[data-dcar-count]', c);
    if (!t || !prev) return;
    const n = t.children.length;
    const idx = () => Math.round(t.scrollLeft / t.clientWidth);
    const upd = () => { const i = idx(); prev.disabled = i <= 0; next.disabled = i >= n - 1; if (cnt) cnt.textContent = (i + 1) + ' / ' + n; };
    prev.addEventListener('click', () => t.scrollBy({ left: -t.clientWidth }));
    next.addEventListener('click', () => t.scrollBy({ left: t.clientWidth }));
    let r; t.addEventListener('scroll', () => { cancelAnimationFrame(r); r = requestAnimationFrame(upd); }, { passive: true });
    upd();
  });

})();

// designer dropdown (phone): pick a name, go there
document.querySelectorAll('[data-dsel]').forEach(sel => sel.addEventListener('change', () => { if (sel.value) location.href = sel.value; }));

// download centre: grid from assets/downloads.json, search + category + file-type filter
document.querySelectorAll('[data-dlc]').forEach(async root => {
  const list = root.querySelector('[data-dlc-list]'), cats = root.querySelector('[data-dlc-cats]'), types = root.querySelector('[data-dlc-types]'), q = root.querySelector('[data-dlc-q]'), count = root.querySelector('[data-dlc-count]'), gen = root.querySelector('[data-dlc-general]'), des = root.querySelector('[data-dlc-des]');
  const L = (root.querySelector('[data-dlc-labels]') || {}).dataset || {};
  let data; try { data = await fetch(root.dataset.src).then(r => r.json()); } catch (e) { return; }
  // x: 1 = a duplicate (e.g. the 2THRD Chair 141 DS versions): kept for its own product page, not listed in the library
  const items = (data.items || []).filter(i => !i.x), general = data.general || [];
  const esc = s => String(s || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const catList = [...new Set(items.map(i => i.c))];
  let cat = '', type = '', term = '', dsg = '';
  const want = new URLSearchParams(location.search).get('dl') || '';
  const wantType = new URLSearchParams(location.search).get('type') || ''; // ?type=p: only product passports, ?type=z: only 3D files
  const link = (href, label, ext, file) => `<a href="${esc(href)}" ${ext ? 'target="_blank" rel="noopener"' : `download="${esc(file || '')}"`}><span class="ul">${esc(label)}</span> ${ext ? '↗' : '↓'}</a>`;
  /* items without a product handle: no link (and never the ?dl= highlight, which an empty handle used to match) */
  const tile = i => { const tag = i.h ? `a href="/products/${esc(i.h)}"` : 'div', end = i.h ? 'a' : 'div'; return `<div class="dlc-tile${want && i.h === want ? ' hit' : ''}"${i.h ? ` id="dl-${esc(i.h)}"` : ''}>
      <${tag} class="dlc-pic">${i.i ? `<img src="${esc(i.i)}" alt="${esc(i.t)}" loading="lazy">` : ''}</${end}>
      <div class="dlc-cap">
        <${tag} class="dlc-title">${esc(i.t)}</${end}>
        <span class="label muted">${i.d ? esc(i.d) + ' · ' : ''}${esc(i.c)}</span>
        <div class="dlc-links label">${i.z ? link(i.z, i.zl || L.zip || '3D files') : ''}${i.p ? link(i.p, L.pdf || 'Product passport', false, `${i.t} - Product passport.pdf`) : ''}${(i.o || []).map(o => link(o[1], o[0])).join('')}${i.i ? link(i.i, L.photo || 'Photo', true) : ''}</div>
      </div>
    </div>`; };
  /* "Fabric samples" (?type=f): the grid shows the fabric colours we have a photo of instead of the products, from assets/fabrics.json */
  let fabrics = null;
  const fabTiles = () => {
    const t = term.trim().toLowerCase(), cards = fabrics.cards || {};
    const card = c => cards[c] ? link(cards[c], `${L.fcard || 'Fabric card'} ${c.replace('Cat. ', '')}`, false, `${L.fcard || 'Fabric card'} ${c}.pdf`) : '';
    const out = [];
    (fabrics.items || []).forEach(f => {
      if (f.s) f.s.forEach(([v, img]) => { if (!t || (f.f + ' ' + v).toLowerCase().includes(t)) out.push(`<div class="dlc-tile dlc-fab"><a href="${esc(img)}" target="_blank" rel="noopener" class="dlc-pic"><img src="${esc(img)}&width=500" alt="${esc(f.f + ' ' + v)}" loading="lazy"></a><div class="dlc-cap"><span class="dlc-title">${esc(v)}</span><span class="label muted">${esc(f.f)} · ${esc(f.c)}</span><div class="dlc-links label">${link(img, L.fimg || 'Photo', true)}${card(f.c)}</div></div></div>`); });
    });
    return out;
  };
  const render = () => {
    root.classList.toggle('dlc-fabmode', type === 'f');
    if (type === 'f') {
      if (!fabrics) { fetch(root.dataset.fabrics).then(r => r.json()).then(j => { fabrics = j; render(); }).catch(() => {}); return; }
      const out = fabTiles();
      list.innerHTML = out.join('') || `<p class="dlc-empty">${esc(L.empty || 'Nothing found.')}</p>`;
      if (count) count.textContent = `${out.length} ${L.fcount || 'colours'}`;
      return;
    }
    const t = term.trim().toLowerCase();
    const hits = items.filter(i => (!cat || i.c === cat) && (!dsg || i.d === dsg) && (!type || i[type]) && (!t || i.t.toLowerCase().includes(t) || (i.d || '').toLowerCase().includes(t)));
    list.innerHTML = hits.map(tile).join('') || `<p class="dlc-empty">${esc(L.empty || 'Nothing found.')}</p>`;
    if (count) count.textContent = `${hits.length} ${L.count || 'products'}`;
  };
  /* a photo link in downloads.json that is gone from Files (404): the product's own photo instead, else no photo */
  list.addEventListener('error', async e => {
    const img = e.target;
    if (img.tagName !== 'IMG' || img.dataset.fallback) return;
    img.dataset.fallback = '1';
    const box = img.closest('[id^="dl-"]'), old = img.getAttribute('src');
    const photoLinks = box ? [...box.querySelectorAll('a')].filter(a => a.getAttribute('href') === old) : [];
    try {
      const p = box && await fetch(`/products/${box.id.slice(3)}.js`).then(r => r.ok ? r.json() : null);
      if (p && p.featured_image) { img.src = p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=600'; photoLinks.forEach(a => { a.href = p.featured_image; }); return; }
    } catch (err) {}
    img.remove(); photoLinks.forEach(a => a.remove());
  }, true);
  if (gen && general.length) gen.innerHTML =`<span class="muted">${esc(L.general || 'For all products')}</span><div class="dlc-links label">${general.map(g => link(g.u, g.t, false, `${g.t}.pdf`)).join('')}</div>`;
  // picking any filter starts a fresh search: the typed term goes
  const clearQ = () => { if (q) q.value = ''; term = ''; };
  const chips = (nav, key, onPick) => nav && nav.addEventListener('click', e => { const a = e.target.closest(`a[${key}]`); if (!a) return; e.preventDefault(); clearQ(); onPick(a.getAttribute(key)); nav.querySelectorAll('a').forEach(x => x.classList.toggle('on', x === a)); render(); });
  if (cats) cats.innerHTML = `<a href="#" class="on" data-cat="">${esc(L.all || 'All')}</a>` + catList.map(c => `<a href="#" data-cat="${esc(c)}">${esc(c)}</a>`).join('');
  chips(cats, 'data-cat', v => cat = v); chips(types, 'data-type', v => type = v);
  if (des) { [...new Set(items.map(i => i.d).filter(Boolean))].sort((a, b) => a.localeCompare(b)).forEach(n => { const o = document.createElement('option'); o.value = o.textContent = n; des.appendChild(o); }); des.addEventListener('change', () => { clearQ(); dsg = des.value; render(); }); }
  q && q.addEventListener('input', () => { term = q.value; render(); });
  if (want) { const hit = items.find(i => i.h === want); if (hit && q) { q.value = hit.t; term = hit.t; } }
  if (types && (wantType === 'p' || wantType === 'z' || wantType === 'f')) { type = wantType; types.querySelectorAll('a').forEach(x => x.classList.toggle('on', x.dataset.type === wantType)); }
  render();
  if (type && !want) { // after load, so smooth scrolling and scroll restoration don't cancel it
    const go = () => setTimeout(() => (types.closest('.dlc-tools') || types).scrollIntoView({ block: 'start', behavior: 'instant' }), 150);
    document.readyState === 'complete' ? go() : addEventListener('load', go, { once: true });
  }
  if (want) { const el = root.querySelector('.dlc-tile.hit'); el && setTimeout(() => el.scrollIntoView({ block: 'center' }), 100); }
});

// product page: point "CAD, 3D & BIM files" straight at the zip when we have one
document.querySelectorAll('[data-dl-handle]').forEach(async a => {
  try {
    const data = await fetch(a.dataset.dlSrc).then(r => r.json());
    const hit = (data.items || []).find(i => i.h === a.dataset.dlHandle);
    if (hit && hit.z) { a.href = hit.z; a.setAttribute('download', ''); a.removeAttribute('target'); }
    else if (hit) { a.href = `${a.dataset.dlPage}?dl=${encodeURIComponent(hit.h)}`; }
  } catch (e) {}
});

// product page: "Fabric cards" downloads the PDF of a fabric category straight away (no samples request).
// Shown only when the options (YMQ, rendered later) name a fabric from assets/fabrics.json.
document.querySelectorAll('[data-fabric-cards]').forEach(async box => {
  const form = box.closest('.shopify-section, main')?.querySelector('form[action*="/cart/add"]');
  if (!form) return;
  let data; try { data = await fetch(box.dataset.src).then(r => r.json()); } catch (e) { return; }
  const names = (data.items || []).map(f => f.f.toLowerCase()), cards = Object.entries(data.cards || {});
  if (!cards.length) return;
  const show = () => {
    const t = form.textContent.toLowerCase();
    if (!names.some(n => t.includes(n))) return false;
    const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    box.innerHTML = `<span>${esc(box.dataset.label || 'Fabric cards')}</span>` + cards.map(([c, u]) =>
      `<a href="${esc(u)}" download="Lensvelt fabric card ${esc(c.replace('.', ''))}.pdf"><span class="ul">${esc(c)}</span> ↓</a>`).join('');
    box.hidden = false;
    return true;
  };
  if (show()) return;
  const mo = new MutationObserver(() => { if (show()) mo.disconnect(); });
  mo.observe(form, { childList: true, subtree: true });
  setTimeout(() => mo.disconnect(), 20000);
});

// Measuring leads: a sent request form and a downloaded file (CAD/3D zip, fabric card, product passport) are published
// as Shopify customer events. Shopify itself does not see them (requests go by mail); a custom pixel in the admin
// (Settings → Customer events) passes them on to Google Analytics as generate_lead and file_download.
const track = (name, data) => { try { window.Shopify && Shopify.analytics && Shopify.analytics.publish(name, data); } catch (e) {} };
document.addEventListener('submit', e => {
  const f = e.target;
  if (!f.matches || !f.matches('form[action*="/contact"]')) return;
  const v = n => (f.elements[n] && f.elements[n].value) || '';
  track('lensvelt_request_sent', { type: v('contact[Type]') || 'contact', product: v('contact[Product]'), page: location.pathname });
}, true);
document.addEventListener('click', e => {
  const a = e.target.closest && e.target.closest('a[href]');
  if (!a) return;
  const file = (a.getAttribute('href') || '').split('?')[0];
  if (!a.hasAttribute('download') && !/\.(zip|pdf|dwg|skp|rfa|glb|step)$/i.test(file)) return;
  track('lensvelt_file_download', { file: decodeURIComponent(file.split('/').pop()), kind: (file.split('.').pop() || '').toLowerCase(), page: location.pathname });
}, true);

// PDF downloads (product passports, fabric cards) live on Shopify's CDN, another domain, where browsers
// ignore the download attribute and open the PDF instead. Fetch it and save it under a clear file name.
document.addEventListener('click', async e => {
  const a = e.target.closest('a[download]');
  if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
  let u; try { u = new URL(a.href); } catch (err) { return; }
  if (u.origin === location.origin || !/\.pdf$/i.test(u.pathname)) return;
  e.preventDefault();
  const name = a.getAttribute('download') || decodeURIComponent(u.pathname.split('/').pop());
  try {
    const blob = await (await fetch(u.href, { mode: 'cors' })).blob();
    const url = URL.createObjectURL(blob), t = document.createElement('a');
    t.href = url; t.download = name; document.body.appendChild(t); t.click(); t.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  } catch (err) { location.href = u.href; }
});

// a link to a folded block ("CAD & 3D files ↓" → #downloads) opens it before the page jumps there
document.addEventListener('click', e => {
  const a = e.target.closest('a[href^="#"]');
  const d = a && a.getAttribute('href').length > 1 && document.querySelector(a.getAttribute('href'));
  if (d && d.tagName === 'DETAILS') d.open = true;
});

// product tiles: the hover photo counts once it has loaded (.ok); the mouse arriving on a tile loads it right away
(() => {
  const ok = i => { if (i.complete && i.naturalWidth) i.classList.add('ok'); else i.addEventListener('load', () => i.classList.add('ok'), { once: true }); };
  const scan = root => (root.querySelectorAll ? root : document).querySelectorAll('.tile img.alt:not(.ok)').forEach(ok);
  scan(document);
  new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => n.nodeType === 1 && scan(n)))).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('pointerover', e => {
    const i = e.target.closest?.('.tile')?.querySelector('img.alt:not(.ok)');
    if (i && i.loading === 'lazy') i.loading = 'eager';
  });
})();

// cards side by side: the text blocks in one row get the height of the tallest, so the headings line up
// (About "What we stand for", Stories overview). [card, block] pairs.
(() => {
  const sets = [['.abt-vgrid .abt-val', 'p'], ['.stj-grid .stj-cell', '.ptxt-bot']];
  const even = () => sets.forEach(([card, block]) => {
    const els = [...document.querySelectorAll(card)].map(c => c.querySelector(block)).filter(Boolean);
    if (els.length < 2) return;
    els.forEach(el => { el.style.minHeight = ''; });
    const rows = {};
    els.forEach(el => { if (!el.offsetParent) return; const k = Math.round(el.closest(card).getBoundingClientRect().top + scrollY); (rows[k] = rows[k] || []).push(el); });
    Object.values(rows).forEach(r => { if (r.length < 2) return; const h = Math.max(...r.map(el => el.getBoundingClientRect().height)); r.forEach(el => { el.style.minHeight = h + 'px'; }); });
  });
  even();
  let t; addEventListener('resize', () => { clearTimeout(t); t = setTimeout(even, 120); });
  document.fonts && document.fonts.ready.then(even);
  document.addEventListener('click', e => { if (e.target.closest('[data-sfilter]')) setTimeout(even, 60); }); // story filter changes the rows
})();

// newsletter popup (sections/newsletter-popup): shows after a delay or a scroll depth, never over Shopify's cookie banner,
// once per 30 days after a close or a sign-up. The address goes straight to Mailchimp (post-json + JSONP, as their
// embedded form does), so no Shopify customer is created; without JS the form posts to Mailchimp in a new tab.
// In the theme editor the section is re-rendered on every setting change, so the setup runs again on that event.
const newsletterPopup = () => {
  const pop = document.querySelector('[data-nl-popup]');
  if (!pop || pop.dataset.nlInit) return;
  pop.dataset.nlInit = '1';
  const KEY = 'lv-newsletter', DAYS = 30, always = pop.dataset.always === 'true';
  const box = pop.querySelector('.nlp-box'), form = pop.querySelector('[data-nl-form]'), note = pop.querySelector('[data-nl-thanks]');
  const t = k => pop.dataset[k] || '', thanks = note.textContent;
  const remember = v => { try { localStorage.setItem(KEY, JSON.stringify({ v, t: Date.now() })); } catch (e) {} };
  const seen = () => { try { const r = JSON.parse(localStorage.getItem(KEY)); return r && Date.now() - r.t < DAYS * 864e5; } catch (e) { return false; } };
  if (seen() && !always) return;

  let shown = false, closed = false;
  const banner = () => { const b = document.getElementById('shopify-pc__banner'); return b && b.offsetParent !== null && getComputedStyle(b).visibility !== 'hidden'; };
  const show = () => {
    if (shown || closed) return;
    if (banner()) { setTimeout(show, 1500); return; } // the cookie banner first; we come after it has gone
    shown = true; pop.hidden = false; requestAnimationFrame(() => requestAnimationFrame(() => pop.classList.add('in')));
  };
  const close = (keep = true) => {
    if (closed) return; closed = true;
    if (keep && !always) remember('closed');
    pop.classList.remove('in'); pop.classList.add('out');
    setTimeout(() => { pop.hidden = true; }, 450);
  };

  // 0 seconds = no timer, 0 % = no scroll trigger; "always show" (editor) opens at once
  const delay = Math.max(0, +pop.dataset.delay || 0) * 1000, depth = +pop.dataset.scroll || 0;
  if (always) setTimeout(show, 0); else if (delay > 0) setTimeout(show, delay);
  if (depth > 0) {
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - innerHeight;
      if (h > 0 && scrollY / h * 100 >= depth) { removeEventListener('scroll', onScroll); show(); }
    };
    addEventListener('scroll', onScroll, { passive: true });
  }

  pop.querySelectorAll('[data-nl-close]').forEach(b => b.addEventListener('click', () => close()));
  addEventListener('keydown', e => { if (e.key === 'Escape' && shown) close(); });
  document.addEventListener('click', e => { if (shown && !closed && !box.contains(e.target) && !e.target.closest('#shopify-pc__banner, #shopify-pc__prefs')) close(); });

  // Mailchimp answers JSONP on /post-json: {result: "success" | "error", msg: "…"}
  form.addEventListener('submit', e => {
    e.preventDefault();
    const email = form.EMAIL.value.trim(), btn = form.querySelector('[type=submit]');
    const say = (msg, err) => { note.textContent = msg; note.classList.toggle('is-error', !!err); note.hidden = false; };
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say(t('invalid'), true); form.EMAIL.focus(); return; }
    const cb = 'lvNl' + Date.now();
    const url = form.action.replace('/post?', '/post-json?') + '&' + new URLSearchParams(new FormData(form)).toString() + '&c=' + cb;
    const s = document.createElement('script');
    const fail = () => { delete window[cb]; s.remove(); btn.disabled = false; say(t('error'), true); };
    const timer = setTimeout(fail, 12000);
    window[cb] = r => {
      clearTimeout(timer); delete window[cb]; s.remove(); btn.disabled = false;
      if (r && r.result === 'success') { say(thanks); pop.classList.add('done'); remember('signed'); setTimeout(() => close(false), 6000); }
      else {
        const msg = (r && r.msg || '').replace(/^\d+\s*-\s*/, ''); // "0 - Please enter a value" → the text
        say(/already|subscribed/i.test(msg) ? msg : (t('error') + (msg ? ' (' + msg + ')' : '')), true);
      }
    };
    btn.disabled = true; note.hidden = true;
    s.src = url; s.onerror = fail; document.head.appendChild(s);
  });
};
newsletterPopup();
document.addEventListener('shopify:section:load', newsletterPopup);
